import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import CodaLineTable from '@accounting/components/tables/coda-line-table/coda-line-table.vue';
import { CodaLine } from '@modules/accounting/interfaces/coda-line';

@Component({
  name: 'bpc-coda-line-table-input',
  components: {
    'bpc-coda-line-table': CodaLineTable,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class CodaLineTableInput extends mixins(AbstractField) {
  declare $refs: AbstractField['$refs'] & {
    codaLineTable: InstanceType<typeof CodaLineTable> & {
      getEntities(): void;
    };
  };


  @Prop(Array) readonly value: any[];
  @Prop(Object) readonly externalFormModel: object;

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop(String) readonly selectEntity: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default' })
  readonly formConfigName: string;
  @Prop({ type: String, default: 'edit' })
  readonly editFormConfigName: string;
  @Prop({
    type: Array,
    default: () => {
      return ['default'];
    },
  })
  readonly selectConfigName: string[];
  @Prop({ type: Boolean, default: true }) readonly showTableHeader: boolean;
  @Prop({ type: Boolean, default: true }) readonly withFilters: boolean;
  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;
  @Prop({ type: String, default: 'table-input' }) readonly displayConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;
  @Prop({ type: String, default: null }) readonly createFormConfigName: string;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  public entity: CodaLine = null;
  public entityName = 'coda-line';
  public pluralEntityName = 'coda-lines';
  public permissionEntityNameToUse = 'codas';

  getEntities() {
    return this.$refs.codaLineTable?.getEntities();
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  get mode(): string {
    return 'api';
  }

  
}
